import PropTypes from "prop-types";
import { Button, Flex, Result } from "antd";
import { useNavigate } from "react-router";
import { AiOutlineWarning } from "react-icons/ai";

export default function Page404({
    title = "Page Not Available",
    description = "The page you are trying to access is currently not available.",
    style = {},
    buttons = [],
}) {
    const navigate = useNavigate();
    return (
        <Flex
            gap={16}
            justify="center"
            align="center"
            style={{width: "100%", height: "100%", minHeight: "80vh"}}
        >
            <Result
                status="success"
                title={title}
                subTitle={description}
                style={style}
                icon={<AiOutlineWarning size={64}/>}
                extra={
                    buttons?.length > 0 ? buttons : [
                    <Button
                        type="primary"
                        key="go-back"
                        onClick={() => {
                            navigate(-1);
                        }}
                    >
                        Go Back
                    </Button>,
                ]}
            />
        </Flex>
    );
}

Page404.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    style: PropTypes.object,
    buttons: PropTypes.arrayOf(PropTypes.node),
};
